import script from "./BaseVModelView.vue?vue&type=script&lang=js"
export * from "./BaseVModelView.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__